import type {ReactNode} from 'react';

import React, {createContext} from 'react';

import type {Theme} from './theme/default';

export const ThemeContext = createContext<Theme | undefined>(undefined);

type Props = {
  children: ReactNode;
  theme: Theme;
};

const AppThemeProvider = ({children, theme}: Props) => {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

export default AppThemeProvider;
